/**
 * Created by Daniela on 29/09/2016.
 */
import {Pipe, PipeTransform} from "@angular/core";

@Pipe({
    name: 'codigoMask'
})
export class CodigoMaskPipe implements PipeTransform {
    transform(value: any, args: number): any {
        if (value) {
            if (typeof value !== 'string') {
                value = value.toString();
            }

            var valueLength: number = value.length,
                x: any, lenX: any;

            for (x = valueLength, lenX = args; x < lenX; x++) {
                value = "0" + value;
            }

            return value;
        }
    }
}



/** WEBPACK FOOTER **
 ** ./~/angular2-template-loader!./src/app/shared/pipes/codigo.pipe.ts
 **/